import React from "react";
import styles from "./FeatureImageWithBlur.module.scss";
import Image from "next/image";
import ContactUsModalBtn from "@/components/Modal/ContactUs";
import { BreadcrumbJsonLd } from "next-seo";
import Link from "next/link";
import ProductSearch from "@/components/Common/ProductSearch";
import { WHATSAPP_CONTACT_LINK } from "@/utils/Common";

function FeatureImageWithBlur({
  heading,
  description,
  imageSrc,
  variant = "dark",
  showPrimaryButton = false,
  primaryButtonText,
  onClickPrimaryButton,
  primaryButtonComponent, // Custom component to render for primary button
  showSecondaryButton = false,
  secondaryButtonText,
  onClickSecondaryButton,
  secondaryButtonComponent, // Custom component to render for secondary button
  showBreadCrumb = false,
  showSearchBar = false,
  searchProps = {},
}) {
  return (
    <div
      className={`${styles.featureImageWithBlur} ${
        variant === "light" ? styles.light : styles.dark
      }`}
    >
      {/* BreadCrumb */}
      {showBreadCrumb && (
        <div className={styles.breadcrumb}>
          <p className="mt-1 ml-2 py-2">
            <Link
              href={"/industry"}
              passHref={true}
              className={styles.breadcrumbLink}
            >
              Industries
            </Link>{" "}
            <span className={styles.breadcrumbCurrent}>/</span>{" "}
            <span className={styles.breadcrumbCurrent}>{heading}</span>
          </p>
        </div>
      )}
      {/*Image With Container and blur */}
      <div
        className={`${styles.imageWithContainerAndBlur} ${
          variant === "light" ? styles.lightImage : styles.darkImage
        }`}
      >
        <Image
          className={styles.image}
          src={imageSrc}
          fill
          // CWV: this is the LCP hero image. `priority` stops Next.js from
          // lazy-loading it (fixes "Don't lazy load LCP image"); `sizes` lets
          // it serve a right-sized source instead of a full-res image on every
          // device. Container is fixed at height:400px, so no visual change.
          priority
          sizes="100vw"
          alt="Feature Image"
        />
      </div>
      {/* Heading and Description */}
      <div className={styles.headingAndDescription}>
        {/* Heading */}
        <h1
          className={`${styles.heading} ${
            variant === "light" ? styles.lightHeading : styles.darkHeading
          }`}
        >
          {heading}
        </h1>
        {/* Description */}
        <p
          className={`${styles.description} ${
            variant === "light"
              ? styles.lightDescription
              : styles.darkDescription
          }`}
        >
          {description}
        </p>
        {/* Search Bar */}
        {showSearchBar && searchProps && (
          <div className="mt-6 w-full flex justify-center">
            <ProductSearch {...searchProps} transparentBg={true} />
          </div>
        )}
        {/* Buttons */}
        {(showPrimaryButton || showSecondaryButton) && (
          <div className={styles.buttonsRow}>
            {showSecondaryButton && (
              secondaryButtonComponent ? (
                secondaryButtonComponent
              ) : (
                <button
                  className={styles.secondaryButton}
                  onClick={onClickSecondaryButton}
                >
                  {secondaryButtonText ?? ""}
                </button>
              )
            )}
            {showPrimaryButton && (
              primaryButtonComponent ? (
                primaryButtonComponent
              ) : (
                <button
                  className={styles.primaryButton}
                  onClick={onClickPrimaryButton}
                >
                  {primaryButtonText ?? ""}
                </button>
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default FeatureImageWithBlur;
